module.exports = __webpack_public_path__ + "img/印刷电路板(PCB)行业数字化转型场景图谱.961035eb.jpg";